// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonTooltip {
    position: absolute;
    background: rgba(255, 255, 255, 0.95);
    padding: 5px;
    border-radius: 8px;
    font-size: 12px;
    white-space: pre-line;
    text-align: left;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 1px solid #e0e0e0;
    line-height: 1.4;
    backdrop-filter: blur(10px);
    max-width: 240px;
    max-height: calc(100vh - 16px);
    overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/Components/Common/CommonTooltip/CommonTooltip.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,0CAA0C;IAC1C,yBAAyB;IACzB,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAgB;AACpB","sourcesContent":[".commonTooltip {\n    position: absolute;\n    background: rgba(255, 255, 255, 0.95);\n    padding: 5px;\n    border-radius: 8px;\n    font-size: 12px;\n    white-space: pre-line;\n    text-align: left;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    border: 1px solid #e0e0e0;\n    line-height: 1.4;\n    backdrop-filter: blur(10px);\n    max-width: 240px;\n    max-height: calc(100vh - 16px);\n    overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
